@for (value of values; track $index) {
  <div
    [ngClass]="value.hasValue === false ? '' : value.className || 'score--empty'"
    [matTooltip]="this.showTooltip ? value.caption : null"
    [style.opacity]="value.opacity"
    (click)="chartClicked(value)"
  ></div>
}
